import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
const Span = styled.span`
  position: relative;
  top: -2px;
  > svg {
    width: 10px;
    height: 10px;
  }
`;

const Available = ({
  isAgentAvailable
}) => /*#__PURE__*/React.createElement(Span, null, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
  color: isAgentAvailable ? "#7ccc13" : "#f5b723",
  icon: faCircle
}));

Available.propTypes = {
  isAgentAvailable: PropTypes.bool
};
export default Available;